export default "__VITE_PUBLIC_ASSET__7f69849b__"